module.exports = __webpack_public_path__ + "img/U1F64A.81784196.png";